import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import DragHandleOutlinedIcon from "@mui/icons-material/DragHandleOutlined";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardDoubleArrowUpIcon from "@mui/icons-material/KeyboardDoubleArrowUp";
import KeyboardDoubleArrowDownIcon from "@mui/icons-material/KeyboardDoubleArrowDown";
import { ReactNode } from "react";

interface PriorityOption {
  label: string;
  icon: ReactNode;
}

export const PriorityOptions: PriorityOption[] = [
  {
    label: "High",
    icon: <KeyboardArrowUpIcon sx={{ color: "rgba(211, 47, 47, 1)" }} />,
  },
  {
    label: "Medium",
    icon: <DragHandleOutlinedIcon sx={{ color: "rgba(237, 108, 2, 1)" }} />,
  },
  {
    label: "Low",
    icon: <KeyboardArrowDownIcon sx={{ color: "rgba(33, 150, 243, 1)" }} />,
  },
  {
    label: "Highest",
    icon: <KeyboardDoubleArrowUpIcon sx={{ color: "rgba(211, 47, 47, 1)" }} />,
  },
  {
    label: "Lowest",
    icon: (
      <KeyboardDoubleArrowDownIcon sx={{ color: "rgba(33, 150, 243, 1)" }} />
    ),
  },
];
